module.exports = __webpack_public_path__ + "img/img (5).cb8b0022.png";